define('modules/common/directive/StatusBar',[], function() {
	var Directive = function(LoadingHandler) {

		return {
			restrict: 'E',
			/*scope: {

			},*/
			replace: true,
			templateUrl: 'modules/common/view/statusbar.tpl.html',
			controller: ["$scope", function($scope) {
				$scope.isLoading = LoadingHandler.isLoading;
			}],
			link: ["$scope", "element", "attrs", function($scope, element, attrs) {
				$scope.isLoading = LoadingHandler.isLoading;
			}]
		};

	};
	return ["LoadingHandler", Directive];
});
